import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Get } from "../Axios/AxiosFunctions";
import JobsCard from "../Components/JobsCard";
import { recordsLimit, URL, imageUrl } from "../Config/apiUrl";
import ForCompFace from "../assets/images/ForCompFace.png";
import forCompLoc from "../assets/images/forCompLoc.png";
import { Card, Col, Collapse, Container, Image, Row } from "react-bootstrap";
import NullData from "../Components/NullData";
import NoMoreJobs from "./../Components/NoMoreJobs";
function Companyfollowers({ setfooterStyle }) {
  const history = useHistory();
  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  const user = useSelector((state) => state?.authReducer?.user);
  const token = useSelector((state) => state?.authReducer?.access_token);

  // ------------------------------------- states ------------------------------------
  const [jobsData, setJobsData] = useState([]);
  const [previousOffset, setPreviousOffset] = useState(0);
  const [hasMoreJobs, setHasMoreJobs] = useState(true);
  const [page, setPage] = useState(1);
  const [isLoadingMoreJobs, setIsLoadingMoreJobs] = useState(false);
  // ------------------------------------- handlers ------------------------------------
  const getJobs = async () => {
    if (page != 1 && previousOffset === jobsData.length) {
      console.log("abort api calling...");
      setHasMoreJobs(false);
      return;
    }

    const url = URL(
      `company/company-followers/${user?._id}?limit=${recordsLimit}&page=${page}`
    );

    setIsLoadingMoreJobs(true);
    const response = await Get(url, token);
    setIsLoadingMoreJobs(false);

    if (response != undefined) {
      setPage((p) => p + 1);
      setPreviousOffset((p) => p + response?.data?.data?.length * 1);
      setHasMoreJobs(true);
      setJobsData((p) => [...p, ...response?.data?.data]);
    }
  };

  // on Load fire effect
  useEffect(() => {
    getJobs();
  }, []);

  return (
    <div className="applied-jobs-container followers">
      {/* Map company jobs here :) */}
      <InfiniteScroll
        className="company-jobs-container"
        dataLength={jobsData.length}
        next={getJobs}
        hasMore={hasMoreJobs}
        style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", padding: '30px' }}
      >
        {/* <div className="company-jobs-container"> */}
        {jobsData?.length > 0 &&
          jobsData.map((item, i) => (
            <Card
              key={i}
              className="for_comp_main text-center"
              onClick={() => {
                history.push(`/craftman-profile?id=${item?._id}`);
              }}
              style={{ cursor: "pointer" , width: '395px', marginRight: '10px'}}
            >
              <Card.Img
                className="for_comp_main_img"
                src={`${imageUrl}${item?.photo}`}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ForCompFace;
                }}
              />
              <Card.Body>
                <Card.Title className="text-center font-22">
                  {item?.userName}
                </Card.Title>
                <Card.Text>{item?.education}</Card.Text>
                <Card.Text>
                  <div className="d-flex">
                    <Image className="o-f" src={forCompLoc} />{" "}
                    <span className="p-3-lines">{item?.address}</span>
                  </div>
                </Card.Text>

                <div className="for_comp_tags">
                  {item?.skills?.map((e, i) => (
                    <h6 key={i}>{e}</h6>
                  ))}
                </div>
              </Card.Body>
            </Card>
          ))}
      </InfiniteScroll>
      {/* </div> */}
      {jobsData?.length == 0 && !isLoadingMoreJobs && (
        <p>
          <NoMoreJobs text={"No Followers Found"} />
        </p>
      )}
      {isLoadingMoreJobs && <NullData />}
    </div>
  );
}

export default Companyfollowers;
